import { CampaignCreationStoreState } from 'modules/campaign-creation/stores/CampaignCreationStore';

export const getTitle = (state: CampaignCreationStoreState | null) => {
  if (!state) {
    return 'New campaign';
  }

  if (state.engagementDescriptionState?.title) {
    return state.engagementDescriptionState.title;
  }

  if (state.jobDescriptionParsedState?.jobDescriptionParsed.jobTitle) {
    return state.jobDescriptionParsedState.jobDescriptionParsed.jobTitle;
  }

  return 'New campaign';
};
